/* Trust bar: when the items do not fit the screen, scroll them as a slow looping marquee. */
(() => {
  const SPEED = 55; // pixels per second

  const setup = (bar) => {
    const row = bar.querySelector('.mg-trust__row');
    const track = bar.querySelector('.mg-trust__track');
    if (!row || !track) return;
    track.querySelectorAll('[data-clone]').forEach((c) => c.remove());
    bar.classList.remove('is-marquee');
    track.style.removeProperty('--mg-trust-dur');

    const items = [...track.children];
    if (!items.length) return;
    const needed = items.reduce((w, i) => w + i.getBoundingClientRect().width, 0);
    if (needed <= row.clientWidth + 1) return;

    bar.classList.add('is-marquee');
    items.forEach((i) => {
      const c = i.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-clone', '');
      track.appendChild(c);
    });
    track.style.setProperty('--mg-trust-dur', Math.round(needed / SPEED) + 's');
  };

  const all = (root = document) => root.querySelectorAll('[data-mg-trust]').forEach(setup);
  const start = () => all();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', start);
  let t;
  window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(start, 150); });
  document.addEventListener('shopify:section:load', (e) => all(e.target));
})();
